import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=67c0916e&scoped=true"
import script from "./navigation-bar.vue?vue&type=script&lang=js"
export * from "./navigation-bar.vue?vue&type=script&lang=js"
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=67c0916e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0916e",
  null
  
)

export default component.exports